module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.40f7a80.woff2";